import { Box } from '@mui/material';
import { ResponsiveBar } from '@nivo/bar';
import ChartSection from '../shared/ChartSection';
import ChartTooltip from '../shared/ChartTooltip';
import useNivoTheme from '../shared/useNivoTheme';

const shortName = full => {
    const parts = (full || '').trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '—';
    if (parts.length === 1) return parts[0];
    return parts[0][0] + '. ' + parts[parts.length - 1];
};

export default function BiggestTraders({ data }) {
    const { theme, colors } = useNivoTheme();
    if (!data || data.length === 0) return null;

    const chartData = data.slice(0, 12).map(t => ({
        id: t.name,
        name: shortName(t.name),
        'Buy Volume': Math.round(t.buy_volume / 1e6),
        'Sell Volume': Math.round(t.sell_volume / 1e6),
    }));

    return (
        <ChartSection
            id="biggest-traders"
            title="Who are the biggest traders in Congress?"
            subtitle="Ranked by total estimated dollar volume ($M)"
        >
            <Box sx={{ height: 420 }}>
                <ResponsiveBar
                    data={chartData}
                    keys={['Buy Volume', 'Sell Volume']}
                    indexBy="name"
                    margin={{ top: 20, right: 140, bottom: 60, left: 60 }}
                    padding={0.3}
                    colors={[colors.buyFg, colors.sellFg]}
                    borderRadius={3}
                    enableLabel={false}
                    axisLeft={{
                        format: v => '$' + v + 'M',
                        legend: 'Volume ($M)',
                        legendPosition: 'middle',
                        legendOffset: -50,
                    }}
                    axisBottom={{ tickRotation: -30 }}
                    legends={[
                        {
                            dataFrom: 'keys',
                            anchor: 'top-right',
                            direction: 'column',
                            translateX: 120,
                            itemWidth: 110,
                            itemHeight: 20,
                            symbolSize: 10,
                            itemTextColor: '#9ca3af',
                        },
                    ]}
                    tooltip={({ id, value, data: d, color }) => (
                        <ChartTooltip
                            title={d.id}
                            rows={[
                                {
                                    label: id,
                                    value: '$' + value.toLocaleString() + 'M',
                                    color,
                                },
                            ]}
                        />
                    )}
                    theme={theme}
                />
            </Box>
        </ChartSection>
    );
}
